import React from "react";
import Table from "../../Common/Table";
import Pagination from "../../Common/Pagination";
import useAddBilling from "./useAddBilling";

const BillingPlans = () => {
  const {
    columns,
    currentRows,
    totalRows,
    currentPage,
    rowsPerPage,
    handlePageChange,
    handleRowsPerPageChange,
  } = useAddBilling();
  return (
    <div className="w-full flex flex-col my-5 md:my-8 px-5">
      <div
        className="bg-white text-G500 rounded-[10px] px-4 py-2"
        style={{ boxShadow: "1px 17px 44px 0px #A5A3A31A" }}
      >
        <h1 className="text-lg md:text-xl xl:text-2xl font-medium">Current Plan</h1>
        <p className="text-sm md:text-[16px] mt-1 md:mt-3">No active subscription</p>
      </div>
      <div className="flex justify-between mt-5">
        <div>
          <h1 className="text-G500 text-xl xl:text-2xl font-medium">
            Invoice list
          </h1>
        </div>
        <button className="bg-buttoncolor text-white font-medium md:px-6 py-2 px-3 text-sm xl:text-base rounded-lg">
          Export
        </button>
      </div>

      <div className="py-3">
        <Table columns={columns} data={currentRows} />
        {/* Pagination */}

        <Pagination
          currentPage={currentPage}
          rowsPerPage={rowsPerPage}
          totalRows={totalRows}
          onPageChange={handlePageChange}
          onRowsPerPageChange={handleRowsPerPageChange}
        />
      </div>
    </div>
  );
};

export default BillingPlans;
